const items = [
  "50+ tipos de café especial",
  "Primeira aguardente de café do Brasil",
  "Queijo Canastra legítimo",
  "Campeã ExpoCachaça",
  "Café do Jacu moído na hora",
  "Produtos premiados no Brasil e exterior",
  "Boutique no centro histórico de Alfenas",
  "Nota 4.8 no Google · 118 avaliações",
];

export default function Marquee() {
  return (
    <section
      data-testid="marquee-section"
      className="relative bg-espresso border-y border-cream/10 py-8 md:py-12 overflow-hidden"
    >
      <div className="marquee-track whitespace-nowrap">
        {[...items, ...items].map((t, i) => (
          <span
            key={i}
            className="font-mono text-[13px] md:text-base tracking-[0.25em] uppercase text-cream/80 px-10 flex items-center gap-10"
          >
            {t}
            <span className="inline-block w-2 h-2 rounded-full bg-gold shadow-[0_0_12px_rgba(196,137,61,0.4)]" />
          </span>
        ))}
      </div>
    </section>
  );
}
